import { SystemMaintenanceEventSearchRequestQuery, SystemMaintenanceEventsSearchResponse } from '@lio/api-types';
import { systemManagementKeys } from '@services/systemManagement/keys';
import { getSystemMaintenanceParamsQuery } from '@services/systemManagement/systemManagement.helpers';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchSystemMaintenanceEvents = (
  { ...params }: SystemMaintenanceEventSearchRequestQuery,
  enabled: boolean = true,
) => {
  const client = useClient();
  const result = useQuery({
    queryKey: systemManagementKeys.eventsSearch({ ...params }),
    placeholderData: keepPreviousData,
    queryFn: () => {
      const url = `system-management/system-maintenance-event?${getSystemMaintenanceParamsQuery(params)}`;
      return client.get(url).json<SystemMaintenanceEventsSearchResponse>();
    },
    enabled,
  });
  return { ...result, searchSystemMaintenance: result.data };
};
